// extracted by mini-css-extract-plugin
export default {"brand_categories_item":"style_brand_categories_item__bsHVY","brands_simple":"style_brands_simple__2P7ey"};